// // actionResolver.js
// export const getProfileActionType = (profile) => {
//   if (!profile) return "DEFAULT";

//   if (profile.interestAccepted) return "INTEREST_ACCEPTED";
//   if (profile.isIgnored) return "IGNORED";
//   if (profile.interestReceived) return "INTEREST_RECEIVED";
//   if (profile.interestSent) return "INTEREST_SENT";

//   return "DEFAULT";
// };



export const getProfileActionType = (profile) => {
  if (!profile) return "DEFAULT";

  // 1️⃣ Highest priority — IGNORE overrides everything
  if (profile.isIgnored || profile.ignored) {
    return "IGNORED";
  }

  // 2️⃣ Interest received
  if (profile.interestReceived) {
    return "INTEREST_RECEIVED";
  }

  // 3️⃣ Interest accepted
  if (profile.interestAccepted) {
    return "INTEREST_ACCEPTED";
  }

  // 4️⃣ Interest sent
  if (profile.interestSent) {
    return "INTEREST_SENT";
  }

  return "DEFAULT";
};
